// Lixeira de 30 dias (0.65): tudo o que é excluído vai para cá e pode ser restaurado até 30 dias depois.
// Cada tipo de item registra como se restaura (registrarRestauro). Depois de 30 dias sai de vez.
import { getDoc, setDoc } from '../store/store';
import type { AbaId, ItemLixeira } from '../store/types';
import { uid } from './date';
import { oferecerDesfazer } from './desfazer';

const DIAS = 30;
type Restauro = (dados: any, extra?: any) => void;
const restauros: Record<string, Restauro> = {};
/** Como restaurar um tipo de item (ex.: "tarefa" volta para o My Planner). */
export const registrarRestauro = (tipo: string, f: Restauro) => { restauros[tipo] = f; };

/** Posição do item na lista de onde sai (para voltar ao mesmo lugar ao restaurar). */
function posicao(tipo: string, dados: any, extra: any): number | undefined {
  try {
    const id = dados?.id;
    if (!id) return undefined;
    if (tipo === 'lista' && extra?.doc && extra?.campo) { const l = (getDoc(extra.doc) as any)?.[extra.campo]; return Array.isArray(l) ? l.findIndex((x: any) => x?.id === id) : undefined; }
    if (tipo === 'caixa') return getDoc('anotacoes').boxes.findIndex(x => x.id === id);
    if (tipo === 'rapida') return getDoc('anotacoes').quick.findIndex(x => x.id === id);
    if (tipo === 'estudos') {
      const fs = getDoc('estudos').ficharios;
      if (extra?.tipo === 'fichario') return fs.findIndex(f => f.id === id);
      const f = fs.find(x => x.id === extra?.fid);
      if (extra?.tipo === 'materia') return f?.materias.findIndex(m => m.id === id);
      return f?.materias.find(m => m.id === extra?.mid)?.paginas.findIndex(p => p.id === id);
    }
  } catch { /* sem posição */ }
  return undefined;
}

/** Guarda uma cópia do item na lixeira antes de excluir. Mostra "🗑️ Item excluído · Desfazer" por 5 segundos (0.67). */
export function paraLixeira(aba: AbaId, tipo: string, titulo: string, dados: any, extra?: any, semDesfazer = false) {
  const pos = posicao(tipo, dados, extra);
  const ex = pos !== undefined && pos >= 0 ? { ...(extra ?? {}), pos } : extra;
  const item: ItemLixeira = { id: uid(), aba, tipo, titulo: titulo || '—', em: new Date().toISOString(), dados: JSON.parse(JSON.stringify(dados ?? null)), ...(ex !== undefined ? { extra: ex } : {}) };
  setDoc('lixeira', d => ({ itens: [item, ...limpos(d.itens ?? [])].slice(0, 400) }));
  if (!semDesfazer) oferecerDesfazer('excluir', () => { restaurarDaLixeira(item.id); });
  return item.id;
}
const limpos = (l: ItemLixeira[]) => { const lim = Date.now() - DIAS * 864e5; return l.filter(x => new Date(x.em).getTime() >= lim); };
export const itensLixeira = () => limpos(getDoc('lixeira').itens ?? []);
export const diasRestantes = (x: ItemLixeira) => Math.max(0, DIAS - Math.floor((Date.now() - new Date(x.em).getTime()) / 864e5));
export const podeRestaurar = (x: ItemLixeira) => !!restauros[x.tipo];

export function restaurarDaLixeira(id: string) {
  const x = (getDoc('lixeira').itens ?? []).find(y => y.id === id);
  if (!x) return false;
  // o restaurador mais recente do mesmo item (ex.: Desfazer logo depois de excluir) segue o registro do tipo
  const f = restauros[x.tipo];
  if (!f) return false;
  try { f(x.dados, x.extra); } catch { return false; }   // ex.: Diário fechado (o conteúdo é cifrado): o item continua na lixeira
  setDoc('lixeira', d => ({ itens: (d.itens ?? []).filter(y => y.id !== id) }));
  return true;
}
export const excluirDeVez = (id: string) => setDoc('lixeira', d => ({ itens: (d.itens ?? []).filter(y => y.id !== id) }));
export const esvaziarLixeira = () => setDoc('lixeira', () => ({ itens: [] }));
/** Tira da lixeira o que passou de 30 dias (ao abrir o app). */
export function limparLixeiraVelha() {
  const l = getDoc('lixeira').itens ?? [];
  const n = limpos(l);
  if (n.length !== l.length) setDoc('lixeira', () => ({ itens: n }));
}
